/**
 * External Resources and Links
 */

export interface Resource {
  id: string;
  title: string;
  description: string;
  url: string;
  category: "reflector" | "database" | "network" | "project" | "local";
}

export const EXTERNAL_RESOURCES: Resource[] = [
  {
    id: "dvref",
    title: "DVRef Registry",
    description:
      "Official reflector database for YSF and D-STAR networks. Essential for finding available reflectors.",
    url: "https://dvref.com/",
    category: "reflector",
  },
  {
    id: "dstarinfo",
    title: "D-STAR Info",
    description:
      "Comprehensive D-STAR reference including reflector information, linking guides, and gateway documentation.",
    url: "http://www.dstarinfo.com/",
    category: "reflector",
  },
  {
    id: "pistar",
    title: "Pi-Star Reflector Lists",
    description:
      "Reflector information and configuration guides for Pi-Star and hotspot users.",
    url: "https://www.pistar.uk/index.php",
    category: "reflector",
  },
  {
    id: "w0chp",
    title: "W0CHP Digital Radio Lists",
    description:
      "Comprehensive digital radio reference including YSF, D-STAR, and other reflector lists.",
    url: "https://w0chp.radio/digital-radio-lists/",
    category: "reflector",
  },
  {
    id: "xlx556",
    title: "XLX556 Dashboard",
    description:
      "Live dashboard for XLX556 cross-mode reflector showing connected stations and activity.",
    url: "https://xlx556.kq4tnv.net",
    category: "reflector",
  },
  {
    id: "m17-556",
    title: "M17-556 Reflector",
    description:
      "Live dashboard for M17-556 reflector (mrefd) showing connected stations and activity. Registered at DVRef.",
    url: "https://m17-556.kq4tnv.net",
    category: "reflector",
  },
  {
    id: "radioid",
    title: "RadioID Database",
    description:
      "DMR repeater information in the RadioID database for programming and reference.",
    url: "https://radioid.net/database/view/dmr/repeater?id=314452",
    category: "database",
  },
  {
    id: "repeaterbook",
    title: "RepeaterBook Entry",
    description:
      "Official listing in the RepeaterBook database with technical details and coverage information.",
    url: "https://www.repeaterbook.com/repeaters/details.php?state_id=51&ID=23066",
    category: "database",
  },
  {
    id: "brandmeister",
    title: "BrandMeister Network",
    description:
      "Browse the complete BrandMeister talkgroup directory to find regional and special interest groups.",
    url: "https://brandmeister.network/?page=talkgroups",
    category: "network",
  },
  {
    id: "m17",
    title: "M17 Project",
    description:
      "Open-source digital voice protocol for amateur radio. Learn about M17 technology and development.",
    url: "https://m17project.org/",
    category: "project",
  },
  {
    id: "wsdh649",
    title: "WSDH649 GMRS Repeater",
    description:
      "WSDH649 GMRS Repeater in Vista Woods, Stafford, VA serving the local GMRS community.",
    url: "https://wsdh649.net",
    category: "local",
  },
];

export const RESOURCE_CATEGORIES = {
  reflector: "Reflector Registries",
  database: "Repeater Databases",
  network: "Networks",
  project: "Digital Voice Projects",
  local: "Local Resources",
} as const;
